import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 26 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

const lineV = {
  hidden: { y: "115%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.15 + i * 0.14 },
  }),
};

export const MaskedLine = ({ i = 0, className = "", children }) => (
  <span className="block overflow-hidden pb-1">
    <motion.span
      className={`block ${className}`}
      custom={i}
      variants={lineV}
      initial="hidden"
      animate="show"
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ children, className = "", ...props }) => (
  <h2
    {...props}
    className={`font-jost text-lg font-bold uppercase tracking-[0.28em] text-[#4A6753] sm:text-xl ${className}`}
  >
    {children}
  </h2>
);
